import { useAuthStore } from '../stores/auth-store';
import type { LoginFormData } from '../schemas/auth-schemas';

/**
 * Custom hook for authentication operations.
 * Provides a clean interface to the auth store.
 */
export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    loading,
    error,
    errorType,
    login,
    logout,
    clearError,
    checkAuthStatus,
    handleUnauthorized,
    setError,
  } = useAuthStore();

  const handleLogin = async (credentials: LoginFormData) => {
    await login(credentials);
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch {
      /* noop */
    }
  };

  const handleCheckAuthStatus = async () => {
    try {
      await checkAuthStatus();
    } catch {
      /* noop */
    }
  };

  return {
    // State
    user,
    isAuthenticated,
    loading,
    error,
    errorType,
    // Derived state
    isAdmin: user?.isAdmin ?? false,

    // Actions
    login: handleLogin,
    logout: handleLogout,
    clearError,
    checkAuthStatus: handleCheckAuthStatus,
    handleUnauthorized,
    setError,
  };
};

export default useAuth;
